<template>
    <sections>
        <section-hero
            :image="hero.image"
            :imageSet="hero.imageSet"
            :imageSizes="hero.imageSizes"
            heading="Private Lessons"
            content="<article-privates-hero />"
        ></section-hero>
        <section-text
            color="bg-zinc-50"
            heading="Book a Session"
            headingComponent="h2"
            content="<article-privates-contact />"
            buttonText="Contact Lauren"
            buttonRoute="/contact"
        ></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();

// https://www.responsivebreakpoints.com/
// https://cloudinary.com/tools/jpg-to-webp
const hero = {
    imageSizes: '(max-width: 1024px) 100vw, 1024px',
    imageSet: `
        ${$config.public.images}private-lessons-512.webp 512w,
        ${$config.public.images}private-lessons-870.webp 870w,
        ${$config.public.images}private-lessons-1024.webp 1024w
    `,
    image: `${$config.public.images}private-lessons.jpg`,
};

useSeo().buildHead({
    image: $config.public.images + 'private-lessons.jpg',
    title: 'Private Lessons | Lauren Jones',
    description: 'One-to-one sessions with Lauren.',
    index: true,
});
</script>
